import styled from 'styled-components';

import { Address } from 'stories/components/Address';

import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { ReactComponent as IconArrowRight } from 'asserts/icons/ic_arrow_right_black.svg';
import { ReactComponent as IconLogin } from 'asserts/icons/ic_user_verified_lined_login.svg';

const LoginFooter = () => {
  const onClick = () => {
    let openUrl = window.location.origin.includes('metagymdev')
      ? 'https://metagymdev.exbody.com:60007'
      : window.location.origin.includes('.qa.')
      ? 'https://exbody.qa.metafamily.world/'
      : 'https://member.exbody.com';

    window.open(openUrl, 'childWindow', 'width=400');
  };

  return (
    <>
      <Wrapper>
        <InnerWraper>
          <div className="contents">
            <h5>
              아직 엑스바디의 통합회원이 아니시라면,
              <br />
              통합 회원가입 후 서비스를 이용해주세요.
            </h5>
            <button onClick={onClick}>
              엑스바디 통합회원 가입하기
              <IconArrowRight />
            </button>
          </div>
          <IconLogin />
        </InnerWraper>
      </Wrapper>
      <FooterWrapper>
        <Address />
      </FooterWrapper>
    </>
  );
};

export default LoginFooter;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 360px;
  background: ${color.gradientType1};

  div.contents {
    display: flex;
    flex-direction: column;
    gap: 24px;

    h5 {
      color: ${color.black2};
      ${font.h1_regular};
    }

    button {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      gap: 12px;
      width: 252px;
      height: 44px;
      border-radius: 24px;
      border: 1px solid ${color.black2};
      color: ${color.black2};
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
    }
  }
`;

const InnerWraper = styled.div`
  width: 1443px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 147px;
`;

const FooterWrapper = styled.div`
  width: 100%;
  background: ${color.navyLight};

  & > div {
    width: 1443px;
    margin: 0 auto;
    padding: 48px;
  }
`;
